import styled from "@emotion/styled";
import { Box, Pagination, Stack } from "@mui/material";

export const ProductSearchResultsBox = styled(Box)(({ theme }) => ({
	display: "grid",
	gap: theme.spacing(2),
	gridTemplateColumns: "1fr", // <= 375px
	"@media (min-width:376px)": {
		gridTemplateColumns: "repeat(2, minmax(0, 1fr))" // > 375px
	},
	"@media (min-width:901px)": {
		gridTemplateColumns: "repeat(3, minmax(0, 1fr))" // > 900px
	},
	"@media (min-width:1201px)": {
		gridTemplateColumns: "repeat(4, minmax(0, 1fr))" // > 1200px
	},
	"@media (min-width:1921px)": {
		gridTemplateColumns: "repeat(5, minmax(0, 1fr))" // > 1920px
	}
}));

export const PaginationStack = styled(Stack)({
	width: "100%",
	display: "flex",
	flexDirection: "row",
	justifyContent: "center"
});

export const PaginationButton = styled(Pagination)({
	"& .MuiPaginationItem-root.Mui-selected": {
		color: "#fff",
		borderColor: "var(--light-blue-500)",
		backgroundColor: "var(--light-blue-500)"
	},
	"& .MuiPaginationItem-root.Mui-selected:hover": {
		backgroundColor: "var(--light-blue-500)"
	}
});
